import { useMemo } from 'react';

export function useLastWord(text?: string): { before: string; last?: string } {
  return useMemo(() => {
    const trimmed = (text ?? '').trim();
    if (trimmed === '') return { before: '' };
    const idx = trimmed.lastIndexOf(' ');
    if (idx <= 0) return { before: '', last: trimmed };
    return {
      before: `${trimmed.substring(0, idx)} `,

      last: trimmed.substring(idx + 1),
    };
  }, [text]);
}

